<div class="bl-table">
  <p-table
    [columns]="headerTable"
    [value]="bodyTable"
    [responsive]="true"
    (sortFunction)="customSort($event)"
    [customSort]="true"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th
          class="thin-header"
          [ngClass]="{
            sortable: col.field === 'date' || col.field === 'hour' || col.field === 'runmode'
          }"
          [ngStyle]="{ width: col.width }"
          *ngFor="let col of columns"
          [pSortableColumn]="col.field"
        >
          <span> {{ col.header }}</span>
          <p-sortIcon
            *ngIf="col.field === 'date' || col.field === 'hour' || col.field === 'runmode'"
            [field]="col.field"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          >
          </p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
      <tr class="height-thin">
        <td *ngFor="let col of columns" class="row-thin">
          <div [ngSwitch]="col.field">
            <div *ngSwitchCase="'date'">
              {{ rowData[col.field] }}
            </div>
            <div *ngSwitchCase="'hour'">
              {{ rowData[col.field] }}
            </div>
            <div *ngSwitchCase="'runmode'">
              {{ rowData[col.field] }}
            </div>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
